import { Controller } from 'stimulus'
import { getRequest, postRequest } from '@react/helpers/fetch'

export default class extends Controller {
  static targets = ['backdrop', 'drawer', 'content', 'dot']

  connect() {
    this.loaded = false
    this.handleKeydown = this.handleKeydown.bind(this)
    document.addEventListener('keydown', this.handleKeydown)
  }

  disconnect() {
    document.removeEventListener('keydown', this.handleKeydown)
  }

  open(event) {
    event.preventDefault()
    this.drawerTarget.classList.add('is-visible')
    this.backdropTarget.classList.add('is-visible')

    if (this.loaded) {
      this.markSeen()
      return
    }

    getRequest(this.data.get('panelUrl'))
      .then(data => {
        this.contentTarget.innerHTML = data.html
        this.loaded = true
        this.markSeen()
      })
  }

  close(event) {
    if (event) event.preventDefault()
    this.drawerTarget.classList.remove('is-visible')
    this.backdropTarget.classList.remove('is-visible')
  }

  markSeen(event) {
    if (event) event.preventDefault()

    postRequest({ url: this.data.get('seenUrl') })
    if (this.hasDotTarget) this.dotTarget.remove()
  }

  handleKeydown(event) {
    if (event.key === 'Escape') this.close()
  }
}
